import { CloudinaryImage } from "../../../../Atoms/Cloudinary";
import styles from "./ProductPreview.module.scss";
import { MdStar as IconStar } from "react-icons/md";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useRouter } from "next/router";

interface Props {
  name: string;
  poster: string;
  reviews: any;
  location: {
    name: string;
  };
}

export default function ProductPreview({
  name,
  poster,
  location,
  reviews,
}: Props) {
  const router = useRouter();
  const { avgStars, totalRecords } = reviews;
  const roundedRating = (Math.round(avgStars * 10) / 10).toFixed(1);
  const isPaymentPage = router.pathname === "/bookings/[id]" ? true : false;
  return (
    <div className={styles.ProductPreview}>
      <div className={styles.ProductPreviewMedia}>
        <div className={styles.ProductPreviewImage}>
          <CloudinaryImage
            src={poster}
            transformations={["w_100", "h_152"]}
            alt={name}
          />
        </div>
      </div>
      <div className={styles.ProductPreviewContent}>
        <div>
          {!isPaymentPage ? (
            <>
              {avgStars > 0 ? (
                <span>
                  <IconStar
                    size={18}
                    color="#F3E53A"
                    style={{ position: "relative", top: 3 }}
                  />
                </span>
              ) : null}
              {totalRecords > 0 ? (
                <div style={{ marginLeft: 5, display: "inline-block" }}>
                  <b>{roundedRating}</b>{" "}
                  <span
                    style={{
                      color: "#8B8B8B",
                    }}
                  >
                    ({totalRecords})
                  </span>
                </div>
              ) : null}
            </>
          ) : (
            <p
              style={{
                color: "#B1B0B0",
              }}
            >
              Booking Your Trip
            </p>
          )}

          <h1 className={styles.ProductPreviewName}>{name}</h1>
          {!isPaymentPage ? null : (
            <p
              style={{
                color: "#B1B0B0",
              }}
            >
              {location.name}
            </p>
          )}
        </div>
        {!isPaymentPage ? (
          <span className={styles.ProductPreviewCity}>
            <FaMapMarkerAlt
              color="#585858"
              size={14}
              style={{
                marginRight: 5,
                position: "relative",
                top: 1,
              }}
            />
            {location.name}
          </span>
        ) : null}
      </div>
    </div>
  );
}
